module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('banco')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "banco"
    }
  }, [_vm._v("Banco:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.dados_bancarios.banco),
      expression: "nota.dados_bancarios.banco"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "banco",
      "for": "banco"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.nota.dados_bancarios, "banco", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Escolha um banco")]), _vm._v(" "), _vm._l((_vm.bancosMain), function(banco) {
    return _c('option', {
      domProps: {
        "value": banco.value
      }
    }, [_vm._v(_vm._s(banco.value + ' - ' + banco.label))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("--------------------------------------------------------------------------")]), _vm._v(" "), _vm._l((_vm.bancos), function(banco) {
    return _c('option', {
      domProps: {
        "value": banco.value
      }
    }, [_vm._v(_vm._s(banco.value + ' - ' + banco.label))])
  })], 2), _vm._v(" "), (_vm.errors.first('banco')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('banco')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('conta corrente')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "conta corrente"
    }
  }, [_vm._v("Conta Corrente:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "conta corrente",
      "type": "text",
      "mask": ['###-X', '####-X', '#####-X', '######-X', '#######-X', '########-X', '#########-X'],
      "tokens": _vm.customTokens,
      "masked": ""
    },
    model: {
      value: (_vm.nota.dados_bancarios.conta),
      callback: function($$v) {
        _vm.$set(_vm.nota.dados_bancarios, "conta", $$v)
      },
      expression: "nota.dados_bancarios.conta"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('conta corrente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('conta corrente')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('agência')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "agência"
    }
  }, [_vm._v("Agência:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|agency'),
      expression: "'required|agency'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "agência",
      "type": "text",
      "mask": ['####-X'],
      "tokens": _vm.customTokens,
      "masked": ""
    },
    model: {
      value: (_vm.nota.dados_bancarios.agencia),
      callback: function($$v) {
        _vm.$set(_vm.nota.dados_bancarios, "agencia", $$v)
      },
      expression: "nota.dados_bancarios.agencia"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('agência')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('agência')))]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Dados bancários")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8393327c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacoes/modulos/dadosBancarios.vue
// module id = 2037
// module chunks = 1